import * as React from "react";
import { PbrInputMask } from "../PbrInput/PbrInputMask";
import { WrappedFormUtils } from "antd/lib/form/Form";
import { useState } from "react";

export interface IPbrInputCNJProps {
    title: string;
    name: string;
    formWrapper: WrappedFormUtils;
    required?: boolean
    placeholder?: string;
    value?: string;
    onChange?: React.ChangeEventHandler<HTMLInputElement>
    disabled?: boolean
}
export const PbrInputCNJ: React.FC<IPbrInputCNJProps> = ({
    formWrapper,
    placeholder,
    title,
    name,
    required,
    value,
    onChange,
    disabled
}) => {

    const [mask] = useState("9999999-99.9999.9.99.9999");

    const validators = (rule, v, callback) => {
        if (v) {
            minDigitsValidator(rule, v, callback)
            cnjValidator(rule, v, callback)
        }
        else {
            callback();
        }
    }

    const minDigitsValidator = (rule, v, callback) => {
        const onlyDigits = v.replace(/([^\d])+/gim, '')
        if (onlyDigits.length === 20) {
            callback()
        } else {
            callback(`O ${title} deve conter no mínimo 20 caracteres`)
        }
    }
    const cnjValidator = (rule, v, callback) => {
        const cnjFormatValidator = /^\d{7}[-]?\d{2}[.]?\d{4}[.]?\d{1}[.]?\d{2}[.]?\d{4}$/;
        const isCNJ = cnjFormatValidator.exec(v);
        if (isCNJ) {
            callback();
        } else {
            callback("Código inválido");
        }
    }

    return (
        <PbrInputMask
            disabled={disabled}
            formItemProps={{ label: title }}
            placeholder={placeholder}
            name={name}
            maskChar={null}
            mask={mask}
            value={value}
            onChange={onChange}
            title={title}
            maxLength={20}
            formWrapper={formWrapper}
            rules={[
                { required, message: "Campo obrigatório" },
                {
                    validator: validators
                }]}
        />
    );
}



// WEBPACK FOOTER //
// ./src/components/common/PbrInputCNJ/PbrInputCNJ.tsx